import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/70_card_back_heart_dog/70_card_back_heart_dog"
 * Contains 1 texture(s)
 */
export class CardsBacks70CardBackHeartDogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/70_card_back_heart_dog/70_card_back_heart_dog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '70_heart_dog.png'
    ] as const;
}
